// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"648":"2f07cc52c1e52f67","944":"47a70a342495b9f4"}[chunkId] + ".js";
};